import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../utils/axiosConfig';
import '../styles/SearchPage.css';

const DAY_NAMES_AR = ['الأحد','الإثنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'];
const MONTH_NAMES_AR = ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];

function formatDateArabic(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return `${DAY_NAMES_AR[d.getDay()]}، ${d.getDate()} ${MONTH_NAMES_AR[d.getMonth()]}`;
}

export default function SearchPage() {
  const [phone, setPhone] = useState('');
  const [bookings, setBookings] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!phone.trim()) return toast.error('أدخل رقم الهاتف');
    setLoading(true);
    setSearched(false);
    try {
      const { data } = await api.get('/backoffice/bookings/by-phone', {
        params: { phone: phone.trim() },
      });
      if (data.success) {
        setBookings(data.bookings || []);
        setCustomer(data.customer);
        setSearched(true);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'حدث خطأ');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async (booking) => {
    if (!window.confirm(`إلغاء حجز ${booking.full_name || booking.phone} بتاريخ ${booking.date} الساعة ${booking.time}؟\nسيتم إرسال رسالة SMS للعميل.`)) {
      return;
    }
    try {
      const { data } = await api.delete(`/backoffice/bookings/${booking.id}`);
      if (data.success) {
        toast.success(data.message);
        if (data.sms_sent) toast.info('تم إرسال SMS للعميل');
        setBookings((prev) => prev.filter((b) => b.id !== booking.id));
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'حدث خطأ');
    }
  };

  return (
    <div className="search-page">
      <h1>بحث بالهاتف</h1>
      <p className="search-sub">ابحث عن حجوزات عميل باستخدام رقم الهاتف</p>

      <form onSubmit={handleSearch} className="search-bar">
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="أدخل رقم الهاتف... 05XXXXXXXX"
          dir="ltr"
        />
        <button type="submit" disabled={loading}>
          {loading ? 'جاري البحث...' : 'بحث'}
        </button>
      </form>

      {searched && (
        <div className="search-results">
          {customer && (
            <div className="customer-info-card">
              <span className="customer-icon">&#128100;</span>
              <div>
                <div className="customer-name">{customer.full_name}</div>
                <div className="customer-phone" dir="ltr">{customer.phone}</div>
              </div>
            </div>
          )}

          {bookings.length === 0 ? (
            <div className="no-results">
              <span className="no-results-icon">&#128269;</span>
              <p>{customer ? 'لا توجد حجوزات قادمة لهذا العميل' : 'لم يتم العثور على عميل بهذا الرقم'}</p>
            </div>
          ) : (
            <>
              <h2 className="results-count">{bookings.length} حجز قادم</h2>
              <div className="search-bookings-list">
                {bookings.map((b) => (
                  <div key={b.id} className="search-booking-card">
                    <div className="sb-info">
                      <div className="sb-date">{formatDateArabic(b.date)}</div>
                      <div className="sb-details">
                        <span className="sb-time">{b.time}</span>
                        <span className="sb-type">{b.booking_type || '—'}</span>
                      </div>
                    </div>
                    <button className="sb-cancel-btn" onClick={() => handleCancel(b)}>
                      إلغاء الحجز
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
